import { render, staticRenderFns } from "./VerifyTel.vue?vue&type=template&id=af431842&scoped=true"
import script from "./VerifyTel.vue?vue&type=script&lang=js"
export * from "./VerifyTel.vue?vue&type=script&lang=js"
import style0 from "./VerifyTel.vue?vue&type=style&index=0&id=af431842&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af431842",
  null
  
)

export default component.exports